import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLiffProfile } from "../../context/LiffProfileContext";
import { Link } from "react-router-dom";

export default function MenuSection({
  seniorLayout = false,
  sections,
  onLoaded,
}) {
  const { i18n } = useTranslation();
  const { userId } = useLiffProfile();
  const [menuItems, setMenuItems] = useState([]);
  const [error, setError] = useState(null);

  const lang = i18n.language?.startsWith("th") ? "th" : "en";
  const labelOf = (names) => names?.[lang] ?? names?.en ?? names?.th ?? "";

  useEffect(() => {
    try {
      if (!sections?.length) return;
      const menu = sections.find((s) => s.type?.toLowerCase() === "menu");
      if (!menu?.items?.length) return;

      const parsed = menu.items
        .map((it) => {
          const internal = it.targetURI?.startsWith("internal://");
          return {
            image: it.image,
            names: it.names,
            to: internal
              ? it.targetURI.replace(/^internal:\/\//, "/")
              : it.targetURI,
            internal,
            // รองรับ flag “ใหม่” ได้หลายแบบ
            isNew: Boolean(it.isNew || it.badge === "new" || it.tag === "new"),
          };
        })
        .filter((x) => x.image && x.to);

      setMenuItems(parsed.slice(0, 8)); // ภาพมี 8 ช่อง
    } catch (e) {
      console.error(e);
      setError(e?.message || "error");
    }
  }, [sections]);

  useEffect(() => {
    if (menuItems.length) onLoaded && onLoaded();
  }, [menuItems, onLoaded]);

  //if (error || !menuItems.length) return <></>;
  if (error) return <></>;

  const TrackGA = (item, index, label) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "home_menu_click",
      menu_target: item.to,
      menu_index: index,
      menu_name_current_lang: label,
      menu_name_en: item.names?.en,
      menu_name_th: item.names?.th,
      user_id: userId || undefined,
    });
  };

  const ItemCard = ({ item, index }) => {
    const label = labelOf(item.names);
    const Card = (
      <div className="relative">
        {/* ป้าย NEW */}
        {item.isNew && (
          <div className="absolute -right-1 -top-1 z-10">
            <span className="px-1.5 py-[2px] text-[10px] font-extrabold bg-red-500 text-white rounded-full shadow">
              NEW
            </span>
          </div>
        )}
        {/* กรอบไอคอน */}
        {/* กล่องไอคอน: ล็อกสัดส่วนคงที่ + ขนาดคงที่ */}
        <div className="p-2">
          <div className="relative mx-auto aspect-square w-12">
            <img
              src={item.image}
              alt={label}
              className="absolute inset-0 w-full h-full object-contain"
              loading="lazy"
              decoding="async"
              width={48} /* ช่วยคำนวณเลย์เอาต์ล่วงหน้า */
              height={48}
              sizes="(max-width: 640px) 48px, 48px"
            />
          </div>
        </div>
      </div>
    );

    return (
      <div className="flex flex-col items-center text-center min-h-[90px]">
        {item.internal ? (
          <Link
            to={item.to}
            className="w-full no-underline"
            onClick={() => TrackGA(item, index, label)}
            aria-label={label}
          >
            {Card}
          </Link>
        ) : (
          <a
            href={item.to}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full no-underline"
            onClick={() => TrackGA(item, index, label)}
            aria-label={label}
          >
            {Card}
          </a>
        )}
        <div className={`${seniorLayout ? "text-base" : "text-sm"} leading-5 h-5 line-clamp-1`}>
          {label}
        </div>
      </div>
    );
  };

  return (
    <div className="w-full px-2 h-[204px]">
      {/* กรอบเขียวโค้งมน พื้นเทาอ่อน เหมือนภาพ */}
      <div className="rounded-3xl border-2 border-[#6FD100] bg-[#fff] mx-4 my-5 px-2 py-2">
        {/* กันเด้งทั้งบล็อก: เผื่อพื้นที่ไว้ตั้งแต่เฟรมแรก (2 แถว) */}
        <div className="min-h-[180px]">
          {/* กริด 4 คอลัมน์ x 2 แถว, ระยะห่างเท่ากัน, จัดกลาง */}
          <div className="mx-auto grid grid-cols-4 gap-x-2 gap-y-1 max-w-[680px]">
            {(menuItems.length ? menuItems : Array.from({ length: 8 })).map((it, idx) => (
              menuItems.length ? (
                <ItemCard key={idx} item={it} index={idx} />
              ) : (
                /* skeleton ขนาดเท่าเซลล์จริง */
                <div key={idx} className="rounded-2xl border border-gray-200 bg-gray-100 animate-pulse min-h-[90px]" />
              )
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
